import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { throttle } from 'throttle-debounce';
import { withNamespaces } from 'react-i18next';

// FIXME We are just using jump.js here, we should think about a way of doing the same thing without it.
// Probably window.scroll({ top: y, left: x, behavior: 'smooth' }); will do the same thing.
import jump from 'jump.js';

import {
  TableOfContentsStyled,
  Wrapper,
  SectionTableTitle,
} from 'apps/readme/styles';

const TableOfContents = props => {
  const { readme, t } = props;
  const { sectionApps, activeSection, SetActiveSection, editing } = readme;
  const itemsRef = useRef([]);
  const jumpToSection = i => {
    // FIXME - don't reuse sectionApps
    const callback = () => {
      if (editing) {
        const { title, form } = sectionApps[i];
        if (!title) {
          form.fieldStores.get('title').SetFocus(true);
        } else {
          form.fieldStores.get('body').SetFocus(true);
        }
      }
    };
    jump(sectionApps[i].ref, { offset: -70, callback });
  };

  const handleScroll = throttle(100, () => {
    let currentSection = sectionApps
      .slice()
      .reverse()
      .findIndex(
        section =>
          section.ref &&
          Math.floor(section.ref.getBoundingClientRect().top) <= 70,
      );

    currentSection =
      currentSection === -1 ? 0 : sectionApps.length - currentSection - 1;

    if (currentSection !== activeSection) {
      SetActiveSection(currentSection);
    }
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    itemsRef.current = itemsRef.current.slice(0, sectionApps.length);
    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sectionApps]);

  const untitled = t('Untitled Section');

  let acum = 0;
  for (let i = 1; i < activeSection; i += 1) {
    acum -= itemsRef.current[i]?.clientHeight;
    acum -= 16;
    // TODO: This is the margin between the elements, which is 1rem
  }

  const tocOffset = `${acum}px`;
  return (
    <TableOfContentsStyled>
      <Wrapper style={{ position: 'relative', top: tocOffset }}>
        {sectionApps.map((section, i) => (
          <SectionTableTitle
            key={i}
            active={i === activeSection}
            onClick={() => jumpToSection(i)}
            // eslint-disable-next-line no-return-assign
            ref={el => (itemsRef.current[i] = el)}
          >
            {section.title || untitled}
          </SectionTableTitle>
        ))}
      </Wrapper>
    </TableOfContentsStyled>
  );
};

TableOfContents.propTypes = {
  t: PropTypes.func,
  manager: PropTypes.object,
  readme: PropTypes.object,
};

export default withNamespaces()(observer(TableOfContents));
